import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Icon } from '@lomarengas/design-system';
import {
  DataTable,
  DataTableItem,
  PaginationComponent,
  SearchBar,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  CountriesFilter,
  getCountriesAsync,
  selectCountryItems,
  selectCountryItemsLoadingStatus,
  selectCountryPagination,
} from './countriesSlice';
import { LOADING_STATUS, LOCALES } from '../../common/constants';
import { InitialPaginationParameters } from '../../common/types/pagination.types';

function Countries() {
  const dispatch = useAppDispatch();
  const countryItems = useAppSelector(selectCountryItems);
  const countryItemsPagination = useAppSelector(selectCountryPagination);
  const countryItemsLoadingStatus = useAppSelector(
    selectCountryItemsLoadingStatus,
  );

  const initialCountriesFilter: CountriesFilter = {
    PageNumber: InitialPaginationParameters.PageNumber,
    PageSize: InitialPaginationParameters.PageSize,
    searchString: '',
    culture: LOCALES.Fi,
  };

  const [countriesFilter, setCountriesFilter] = useState(
    initialCountriesFilter,
  );

  const [countryTableItems, setCountryTableItems] = useState<DataTableItem[]>(
    [],
  );

  const handleInputChange = event => {
    const { target } = event;
    const { value, name } = target;
    setCountriesFilter({ ...countriesFilter, [name]: value });
  };

  const doSearch = () => {
    countriesFilter.PageNumber = InitialPaginationParameters.PageNumber;
    dispatch(getCountriesAsync(countriesFilter));
  };

  const HandlePaginationClick = (Page: number) => {
    const paginatedFiltering = countriesFilter;
    paginatedFiltering.PageNumber = Page;
    setCountriesFilter(paginatedFiltering);
    dispatch(getCountriesAsync(paginatedFiltering));
  };

  useEffect(() => {
    if (countryItems && countryItems.length > 0) {
      const formattedCountryList: DataTableItem[] = [];
      countryItems?.forEach(item => {
        formattedCountryList.push({
          ItemId: item.id,
          Items: [item.id, item.name],
          Url: `/locations/countries/${item.id}`,
        });
      });
      setCountryTableItems(formattedCountryList);
    }
  }, [countryItems]);

  useEffect(() => {
    doSearch();
  }, []);

  const AddNewButton: JSX.Element = (
    <Link to="/locations/countries/addnew" className="btn btn-blue ps-16">
      <Icon CssClass="me-8" AriaLabel="Uusi" Name="plus" />
      Lisää uusi
    </Link>
  );

  return (
    <>
      <Helmet>
        <title>Sijaintitiedot - Maat - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Sijaintitiedot']}
          Children={AddNewButton}
          Title="Maat"
        />

        <SearchBar
          FreeTextOnChangeHandler={handleInputChange}
          FreeTextPlaceholder="Hae..."
          SearchHandler={doSearch}
          IsLoading={countryItemsLoadingStatus !== LOADING_STATUS.IDLE}
          Value={countriesFilter.searchString}
        />

        {countryItemsLoadingStatus === LOADING_STATUS.IDLE &&
          countryItems !== null &&
          countryItems.length > 0 && (
            <>
              <DataTable
                ColumnWidths={[400, null]}
                Header={['Maan ID', 'Maan nimi']}
                Items={countryTableItems}
                LegendText="maata"
                TotalItems={countryItemsPagination.totalCount}
              />
              <PaginationComponent
                OnPageClick={HandlePaginationClick}
                PaginationData={countryItemsPagination}
              />
            </>
          )}

        {countryItemsLoadingStatus === LOADING_STATUS.IDLE &&
          countryItems.length < 1 && (
            <p>Maita ei löytynyt annetuilla hakuehdoilla.</p>
          )}
      </Container>
    </>
  );
}

export default Countries;
